import {
  GET_PROPERTIES,
  GET_PROPERTIES_SUCCESS,
  GET_PROPERTIES_FAILURE,
  GET_PROPERTY,
  GET_PROPERTY_SUCCESS,
  GET_PROPERTY_FAILURE,
} from './constants';




const initialState = {
  properties: { properties: [], loading: false, loaded: false, error: null },
  property: { property: {}, loading: false, loaded: false, error: null },
}

const property = (state = initialState, action) => {
  switch (action.type) {
    /* — GET ALL PROPERTIES — */
    case GET_PROPERTIES:
      return {
        ...state,
        properties: { ...state.properties, loading: true, error: null },
      };

    case GET_PROPERTIES_SUCCESS:
      return {
        ...state,
        properties: { properties: action.payload, loading: false, loaded: true, error: null },
      };

    case GET_PROPERTIES_FAILURE:
      return {
        ...state,
        properties: { ...state.properties, loading: false, loaded: false, error: action.payload },
      };
    /* — GET PROPERTY — */
    case GET_PROPERTY:
      return {
        ...state,
        property: { loading: true, error: null },
      };

    case GET_PROPERTY_SUCCESS:
      return {
        ...state,
        property: { property: action.payload, loading: false, loaded: true, error: null },
      };

    case GET_PROPERTY_FAILURE:
      return {
        ...state,
        property: { ...state.property, loading: false, loaded: false, error: action.payload },
      };

    default:
      return state;
  }
};

export default property;
